import React from 'react';
import ChoiseBox from '../ChoiceBox/ChoiceBox';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const DifficultyMeter = React.createClass({
	render() {
		const level = this.props.level;
		return (
			<div className={`difficulty-level ${level}`}>
				<svg width="60" viewBox="0 0 92 45">
					<path className="top" d="M24,5.162036 C30.469575,1.861366 37.795957,0 45.557084,0 C53.318211,0 60.644593,1.861366 67.114168,5.162036 L58.092465,20.788084 C54.287994,18.999619 50.039276,18 45.557084,18 C41.074892,18 36.826174,18.999619 33.021703,20.788084 L24,5.162036 L24,5.162036 Z"></path>
					<path className="left" d="M30.572042,44.333988 C29.760808,28.689237 21.37979,15.047029 9.021626,7 L0,22.625914 C6.997244,27.509289 11.778266,35.348919 12.532263,44.334001 L30.572043,44.334001 L30.572042,44.333988 Z" transform="translate(15.286022, 25.667001) scale(-1, 1) translate(-15.286022, -25.667001) "></path>
					<path className="right" d="M91.572042,44.333988 C90.760808,28.689237 82.37979,15.047029 70.021626,7 L61,22.625914 C67.997244,27.509289 72.778266,35.348919 73.532263,44.334001 L91.572043,44.334001 L91.572042,44.333988 Z"></path>
				</svg>
			</div>
		);
	}
});

const Difficulty = React.createClass({
	render() {

		const difficulty = this.props.difficulty;
		const title = this.props.title;
		const recommended = this.props.recommended;
		const extra = this.props.extra;
		const extraClass = this.props.extraClass;

		console.log(`${difficulty}: ${recommended}`);

		return (
			<li className="difficulty">
				<ChoiseBox
					type="radio"
					name="difficulty"
					label={title}
				    add={extra}
				    addClass={extraClass}
				>
					<DifficultyMeter
						level={difficulty}
					/>
				</ChoiseBox>

			</li>
		);
	}
});

export default Difficulty;


/** WEBPACK FOOTER **
 ** ./src/components/Difficulty/Difficulty.js
 **/